/**
 * Keeps the legacy top navigation toggles and body classes in sync outside the routed Vue shell.
 */
import { removeScrollBarOffset, scrollToTop, setScrollBarOffset } from "@/shared/browser/pageDom";

/* eslint-disable-next-line */
(window as any).Menu = {
  opts: {
    menuOpenClass: "menu-open",
  },

  init: function () {
    this.body = document.body;
    this.menuToggle = document.getElementById("menu-toggle");
    this.setListeners();
  },

  setListeners: function () {
    if (this.menuToggle) {
      this.menuToggle.addEventListener("click", (e: Event) => {
        e.preventDefault();
        this.body.classList.toggle(this.opts.menuOpenClass);

        if (this.body.classList.contains(this.opts.menuOpenClass)) {
          setScrollBarOffset();
        } else {
          removeScrollBarOffset();
        }
      });
    }

    window.addEventListener("resize", () => {
      if (this.body.classList.contains(this.opts.menuOpenClass)) {
        this.body.classList.remove(this.opts.menuOpenClass);
        removeScrollBarOffset();
      }
    });

    const scrollTopButton = document.getElementById("footer-scroll-top");
    if (scrollTopButton) {
      scrollTopButton.addEventListener("click", (e: Event) => {
        e.preventDefault();
        scrollToTop();
      });
    }
  },
};

document.addEventListener("DOMContentLoaded", () => {
  /* eslint-disable-next-line */
  (window as any).Menu.init();
});
